export default __webpack_public_path__ + "static/media/creditcard_transparent.970f2368.png";